export interface AppTheme {
  //   text: string;
  //   textSecondary: string;
  //   colorBgRed: string;
  //   colorBgYellow: string;
  //   colorBgLightYellow: string;
  //   colorBgVoliet: string;
  //   colorBgPink: string;
  //   colorBgGreen: string;
  //   colorBgOrange: string;
  //   colorBgTeal: string;
  //   colorBg: string;
  //   borderColor: string;
  //   borderRadius: number;
  //   fontSizeSmall: number;
  //   fontSizeMed: number;
  //   fontSizeLg: number;
  //   fontSizeLgg: number;
  //   paddingSmall: number;
  //   paddingMed: number;
  //   paddingLg: number;
  //   paddingLgg: number;
  //   fontSizeHuge: number;
  //   fontFamily: string;
  // Additional properties for MS Windows theme
  white: string;
  black: string;
  darkShadowColor: string;
  lightShadowColor: string;
  standardBoxShadow: string;
  invertedStandardBoxShadow: string;
  standardBoxShadowNoBottom: string;
  MSBackground: string;
  MSBackgroundLight: string;
  barGradient: string;
  loadingBarFillColor: string;
  loadingBarFillColorCompleted: string;
  gap: string;
  fontNormal: number;
  fontSmall: number;
  fontLarge: number;
}

export const token: AppTheme = {
  white: "#fff",
  black: "#000",
  darkShadowColor: "rgb(209, 205, 215, 0.5)",
  lightShadowColor: "rgb(255, 255, 255, 0.5)",
  standardBoxShadow: `-1px -1px 0px 0px #000 inset, 1px 1px 0px 0px #fff inset,
    -2px -2px 0px 0px #808080 inset, 2px 2px 0px 0px #dbdbdb inset`,
  invertedStandardBoxShadow: `1px 1px 0px 0px #000 inset, -1px -1px 0px 0px #fff inset,
      2px 2px 0px 0px #808080 inset, -2px -2px 0px 0px #dbdbdb inset`,
  standardBoxShadowNoBottom: `-1px 0px 0px 0px #000 inset, 1px 1px 0px 0px #fff inset,
    -2px 0px 0px 0px #808080 inset, 2px 2px 0px 0px #dbdbdb inset`,
  MSBackground: "#bfbfbf",
  MSBackgroundLight: "#C9C9C9",
  barGradient: "linear-gradient(270deg, #1085d2 0%, #00007b 100%)",
  loadingBarFillColor: "#00007B",
  loadingBarFillColorCompleted: "#3DD63F",
  gap: "0.5rem",
  fontLarge: 18,
  fontNormal: 12,
  fontSmall: 8,
};
